import { getDrawings } from "../../DrawingRegisterTab/api";

export const fetchDbDrawings = async ({ project }) => {
  return await getDrawings(project.id)
    .then((response) => {
      console.log({ projectId: project.id, fetchDbDrawings: response });
      return response;
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};

//    const onSelectFromSharepoint = async () => {
//         // TODO: select from sharepoint
//         setLoading(true); // Start loading
//         const siteId =
//           "chinookdt189.sharepoint.com,64dc97a0-0b9b-4dd3-883c-2e95aa812e41,491ce48a-a146-4cb4-9ff8-1f01d53f5070";

//         const filePath =
//           "/drive/root:/PV-CDT-001%2F4%2E%203D%20and%202D%2F0:/children";
//         const fileName = "2D Json Data.json";

//         try {
//           const resp = await secondAxios.get(`/sharepoint/data`, {
//             params: {
//               siteId,
//               filePath,
//               fileName,
//             },
//           });
//           console.log("Response:", resp.data);
//           // data.push(resp.data);
//           setEngData({ ...resp.data[0].fileContent });
//           setSpData([...resp.data[0].fileContent]);
//           setFeedback({
//             open: true,
//             message: "Data loaded successfully!",
//             type: "success",
//           });
//         } catch (error) {
//           console.error("Error fetching data:", error);

//           setFeedback({
//             open: true,
//             message: "Failed to load data. Please try again.",
//             type: "error",
//           });
//         } finally {
//           setLoading(false);
//         }
//       };
